import { useQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import { adaptMotivoNIngresoArray, GET_MOTIVOS_NO_INGRESO } from '../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosNIngreso';
import { adaptMotivoRechazoArray, GET_MOTIVOS_RECHAZO } from '../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosRechazo';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';
import { toast } from 'react-hot-toast';

export const AptoInput = ({
  idEvaluacion,
  handleClickAceptar,
  loadingValidar,
  isReject = false,
  apto,
  fromRI = false
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [rechazo, setRechazo] = useState(isReject ? { idMotivoNoIngreso: 2 } : {});
  const [motivosNoIngreso, setMotivosNoIngreso] = useState([]);
  const [motivosRechazo, setMotivosRechazo] = useState([]);

  const handleChange = (name, value) => {
    setRechazo((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const newInput = useMemo(() => {
    return {
      displayName: isReject ? 'Rechazar' : 'Validar',
      name: 'validacionCoordinador',
      type: 'button',
      isLoading: loadingValidar,
      variant: isReject ? 'outlined' : 'contained',
      col: 30,
      onClick: () => handleOpenModal(),
      disabled: fromRI && !isReject && !apto
    };
  }, [loadingValidar, apto]);



  const { data: motivoNIngresoData } = useQuery(GET_MOTIVOS_NO_INGRESO);

  const { data: motivosRechazoData } = useQuery(GET_MOTIVOS_RECHAZO);

  useEffect(() => {
    if (!motivoNIngresoData) return;

    setMotivosNoIngreso(adaptMotivoNIngresoArray(motivoNIngresoData));
  }, [motivoNIngresoData]);

  useEffect(() => {
    if (!motivosRechazoData) return;

    setMotivosRechazo(adaptMotivoRechazoArray(motivosRechazoData));
  }, [motivosRechazoData]);

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(false);
    setRechazo(isReject ? { idMotivoNoIngreso: 2 } : {});
  };

  const handleOverrideClickAceptar = (rechazo) => {
    if (isReject && !rechazo.idMotivoRechazo)
      return toast.error('Debe seleccionar un motivo de rechazo.');

    handleClickAceptar(rechazo);
    handleClose();
  };

  const validatedInputs = useMemo(() => {
    return inputsValidar.filter((x) => (x.name === 'idMotivoNoIngreso' ||
      x.name === 'idMotivoRechazo') && isReject || x.name === 'observacion'
    ).map((input) => {
      switch (input.name) {
        case 'idMotivoNoIngreso':
          input.options = motivosNoIngreso;
          input.disabled = true;
          break;
        case 'idMotivoRechazo':
          const motivoFallecimientoId = motivosNoIngreso.find((x) => x.displayName.includes('FALLECIO'))?.id;
          input.disabled = !rechazo.idMotivoNoIngreso || rechazo.idMotivoNoIngreso === motivoFallecimientoId;
          input.options = motivosRechazo.filter((x) => x.motivoNIngreso === rechazo.idMotivoNoIngreso);
          break;

        default:
          break;
      }

      return input;
    });
  }, [
    motivosNoIngreso,
    motivosRechazo,
    rechazo,
    idEvaluacion]
  );

  return <>
    <RenderInputsRowByType
      input={newInput}
      value={null}
      handleChange={null} />

    <CustomDialog
      maxWidth='lg'
      fullWidth
      onCancel={() => handleClose()}
      onAccept={() => handleOverrideClickAceptar(rechazo)}
      open={openModal}
      cancelText='Cerrar'
      acceptText='Aceptar'
      title={isReject ? 'Rechazo Coordinador Asistencial' : 'Validacion Coordinador Asistencial'}>

      <Grid
        container
        // justifyContent={'space-between'}
        columnSpacing={3}
        rowSpacing={3}
        columns={100}>

        {validatedInputs.map((input, index) => {
          return (
            <RenderInputsRowByType
              key={`name-${input.name}-index${index}`}
              input={input}
              value={rechazo[input.name]}
              handleChange={handleChange} />);


        })}
      </Grid>
    </CustomDialog>
  </>;
};

const inputsValidar = [
  {
    displayName: 'Motivo no ingreso',
    name: 'idMotivoNoIngreso',
    type: 'select',
    col: 30
  },
  {
    displayName: 'Motivo rechazo',
    name: 'idMotivoRechazo',
    type: 'select',
    col: 30
  },
  {
    displayName: 'Observacion extra',
    name: 'observacion',
    type: 'long_string',
    col: 100
  }];